// any operators needed throughout your application
import "../../operators";

import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import { Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { Observable } from "rxjs/Observable";
import * as fromRootStore from "../../reducers/index";
import * as fromCommonStore from "../../store";
import * as commonActions from "../../store/actions/common.actions";
import { AuthService } from "../../services/index";
import swal from "sweetalert2";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { CommonService, UserService } from "../../services/index";

import { TabsComponent } from "./tabs.component";

@Component({
  moduleId: module.id,
  templateUrl: "./home.component.html",
  host: { "(window:keydown)": "hotkeys($event)" },
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  title = "app";
  @ViewChild(TabsComponent) tabsComponent;

  menus: any;
  config: any;
  user: any;
  menulist: any;
  menuIcon: string = "fa-arrow-left";
  @ViewChild("sideNavMenu") sideNavMenu;
  typeList = ["INWARD", "OUTWARD"];
  companyStoreSub;
  isHomeLoaded: boolean = false;
  isauth$: Observable<boolean>;
  appVersion$: Observable<string>;
  constructor(
    private logger: NGXLogger,
    private commonService: CommonService,
    private userService : UserService,
    private store: Store<fromRootStore.State>,
    private comstore: Store<fromCommonStore.State>,
    private router: Router,
    private authService: AuthService
  ) {
    this.logger.debug("AppComponent Rendered");
  }
  addMenuDetail(children) {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child.type == "CHILD" && child.component != "") {
        this.menulist.push(Object.assign(child));
      }
      this.addMenuDetail(child.children);
    }
  }
  ngOnInit() {
    let that = this;

    this.commonService
      .getMenus({})
      .then((res: any) => {
        that.menus = res.menu;
        let menu = _.filter(res.menu, { enabled: "true" });
        that.user = res.user;
        that.user.params = that.user.params ? JSON.parse(that.user.params) : {};

        that.userService.setUserDet(that.user);
        that.menulist = [];
        that.addMenuDetail(res.menu);
        that.tabsComponent.setData(that.menus, that.menulist, that.user);
      })
      .catch((error: any) => {
        console.log(error);
      });

    this.appVersion$ = this.store.select(fromRootStore.getAppVersion);

    this.comstore.select(fromCommonStore.getAuth).subscribe((auth: any) => {
      this.isauth$ = auth;
      if (this.isauth$["islogin"]) {
        this.comstore.dispatch(new commonActions.LoadAllItem());
        this.comstore.dispatch(new commonActions.LoadAllParty());
      }
    });
  }


  hotkeys(event) {
    let tabObj: object;
    if (event.ctrlKey && event.keyCode === 49) {
      tabObj = _.find(this.menus["Master"], { name: "Item" });
    }
    if (event.ctrlKey && event.keyCode === 50) {
      tabObj = _.find(this.menus["Master"], { name: "Company" });
    }
    if (event.ctrlKey && event.keyCode === 51) {
      tabObj = _.find(this.menus["Master"], { name: "Party" });
    }

    if (!_.isEmpty(tabObj)) {
      this.addTab(tabObj);
    }
  }

  public addTab(tabObj: any): void {
    $(".dropdown-menu").css("display", "none");
    setTimeout(function() {
      $(".dropdown-menu").css("display", "");
    }, 1000);
    tabObj["name"] = tabObj["component"];
    this.tabsComponent.openTab(tabObj);
  }

  onOpenCloseMenu() {
    this.menuIcon = this.sideNavMenu.opened ? "fa-bars" : "fa-arrow-left";
    this.sideNavMenu.toggle();
  }

  logout() {
    let that = this;

    swal({
      title: "Are you sure to Logout?",
      //text: 'You will not be able to recover this Item [' + row['item_name'] + ']',
      type: "warning",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then(
      function(res: any) {
        that.authService
          .logout({})
          .then((res: any) => {
            if (res.success) {
              that.comstore.dispatch(new commonActions.IsAuth(true));
              //localStorage.setItem('currentUser', 'Abdul');
              that.router.navigate(["login"], { skipLocationChange: true });
            }
          })
          .catch((error: any) => {
            console.log(error);
          });
      },
      function(dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/home/home.component.ts